import axios from "@api/axiosInstance";
import { queryClient } from "@hooks/useGlobalState";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  CadModelCategoryFilterObjectData,
  CadModelCategoryFilterResponse,
  CreateProfileConfigurationRequest,
  ProfileConfiguration,
  ProfileConfigurationsClient,
  UpdateProfileConfigurationRequest,
} from "./apiClient";

const profileConfigurationsClient = new ProfileConfigurationsClient(undefined, axios);

export const useProfileConfigurations = (profileId: string, options?: any) => {
  return useQuery<CadModelCategoryFilterResponse | null>({
    ...options,
    queryKey: ["profileConfigurations", profileId], // Include profileId in the key
    queryFn: async () => profileId ? profileConfigurationsClient.getCadModelCategoryFiltersByProfile(profileId) : Promise.resolve(null),
    enabled: !!profileId, // Ensure query only runs when profileId is truthy
  });
};

export const usePredefinedProfileConfiguration = (options?: any) => {
  return useQuery<CadModelCategoryFilterObjectData[]>({
    ...options,
    queryKey: ["preDefinedProfileConfigurations"],
    queryFn: async () => profileConfigurationsClient.getPredefinedProfileConfiguration(),
  });
};

export const useCreateProfileConfiguration = (options?: any) => {
  return useMutation<ProfileConfiguration>({
    ...options,
    mutationFn: (createProfileConfigurationRequest: CreateProfileConfigurationRequest) => profileConfigurationsClient.createProfileConfiguration(createProfileConfigurationRequest),
    onSuccess: async () => {
      await queryClient.resetQueries({ queryKey: ["profileConfigurations"], exact: false });
      options?.onSuccess?.();
    },
  });
};

export const useUpdateProfileConfiguration = (options?: any) => {
  return useMutation<ProfileConfiguration>({
    ...options,
    mutationFn: ({
      profileConfigurationId,
      updateProfileConfigurationRequest,
    }: {
      profileConfigurationId: string;
      updateProfileConfigurationRequest: UpdateProfileConfigurationRequest;
    }) => {
      return profileConfigurationsClient.updateProfileConfiguration(profileConfigurationId, updateProfileConfigurationRequest);
    },
    onSuccess: async () => {
      await queryClient.resetQueries({ queryKey: ["profileConfigurations"], exact: false });
      options?.onSuccess?.();
    },
  });
};
